import React, { useContext, useEffect } from 'react';
import { useParams } from 'react-router';
import { isSafari, Loader, CookieUtil, PageContext } from '@axiom/ui';

import { EnvUtil } from '../utils/env-util';
import { AuthApi } from '../api/auth-api';

export const MagicLinkPage = () => {
  const { setTitle } = useContext(PageContext);
  const { token } = useParams<{ token: string }>();

  useEffect(() => {
    setTitle('Axiom Law - Signing On');
  }, []);

  useEffect(() => {
    if (!token) {
      window.location.href = '/link-expired';
      return;
    }

    const handleLogin = async () => {
      try {
        const { data: jwt } = await AuthApi.updateTokenLogin({ token });
        const isBrowserSafari = isSafari();
        CookieUtil.setUserCookie(jwt, {
          domain: EnvUtil.cookieDomain,
          isSafari: isBrowserSafari,
        });
        window.location.href = `/sso${window.location.search}`;
      } catch {
        window.location.href = '/link-expired';
      }
    };

    void handleLogin();
  }, [token]);

  return <Loader type="logo" expand="fullscreen" name="MAGIC_LINK_LOADER" />;
};
